import React from 'react'
import { Instagram } from '../../components/Instagram'

const InstagramContainerApollo = ({ ...rest }) => {
  return <Instagram user="cityofhope" {...rest} />
}

export default InstagramContainerApollo
